/**
 * Field values that are used to maintain search and other states.
 */
export class PageSettings {

	public currentPage:number;                  // Which page in the search is this?
	public currentSport:string;                 // What is the currently active sport?
	public initialized:boolean = false;         // Has this object been initialized?
	public lastSearchType:string;               // What was the last search type used?
	public perPageChoice:number;                // How many items per page will be displayed?
	public playerSearchId:number;               // If a player search is specified, what is the player ID?
	public searchByStoryId:string;              // The story ID to search for.
	public searchFullText:string;               // The full-text search query.
	public searchOrderField:string;             // Which field should the results be ordered by?
	public searchSortOrder:string;              // Is the search order ascending or descending?
	public searchStatus:number;                 // Are we searching for all articles, or published, trashed, etc.
	public teamSearchId:number;                 // If a team search is specified, what is the team ID?
	public typeaheadPlayerName:string;          // What player name did we search for?
	public typeaheadSource:string;              // What source did we search for?
	public typeaheadTeamname:string;            // What team name did we search for?
	public startDate:string;                    // Start date for a date search.
	public endDate:string;                      // End date for a date search.
	public currentItemSport:string;             // The Sport to use when creating the next article.

	constructor( values: Object = {} ) {
		Object.assign( this, values );
	}

}



// WEBPACK FOOTER //
// ./src/app/services/news/page-settings.ts